import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'lib-myfort',
  templateUrl: './myfort.component.html',
  styleUrls: ['./myfort.component.css']
})
export class MyfortComponent implements OnInit {

  

  @Input() name : String;
  @Input() message: String;
  @Input() myimage : any;
  @Input() textvalue : '';
  @Input() navtag1 : String;
  @Input() navtag2 : String;
  @Input() navtag3 : String;
  @Input() navtag4 : String;
  @Input() navtag5 : String;
  @Input() logo : any;

  
  constructor() { }

  ngOnInit() {
    // this.name = 'gaurav';
    // this.message = 'good';
    // this.myimage = 'No Image';
    // this.navtag1 = 'About';
    // this.navtag2 = 'Home';
    // this.navtag3 = 'Contact Us';
    // this.navtag4 = 'Products';
    // this.navtag5 = 'Career';

 // console.log(textvalue);
  }

  onKey(event :any){
    this.textvalue = event.target.value;
  }

}
